import React, { ReactElement, useContext, useState} from 'react';
import { verifyTravelsByPhoneAndBirthdate, searchTravelsByPhoneAndBirthdate} from '../../api/travelApiClient';
import { TravelQuotationContext } from '../../contexts/TravelQuotationContext';
import { ITravelIdentificationCodeRequest, ITravelIdentificationCodeResponse, ITravelVerificationResponse, ITravelPrimaryInsured } from '../../model/travel';
import { TravelConfirmDialog } from '../dialogs/TravelConfirmDialog';
import { TravelNoDataDialog } from '../dialogs/TravelNoDataDialog';
import { TravelPhoneNumberDialog } from '../dialogs/travelPhoneDialog';
import "./index.scss";

/*
    Це компонент-вропер для пошуку за номером та датою ародження
    Якщо знаходимо клієнта, то викликаємо onCustomerFound, який там потім все розрулить
*/

export const FindOnTravel = ({ onCustomerFound }:{ onCustomerFound: (arg0:ITravelPrimaryInsured) => void }):ReactElement => {

    const {setOpenErrorMessageDialog, setTab} = useContext(TravelQuotationContext);
    const [identificationData, setIdentificationData] = useState<ITravelIdentificationCodeRequest>(null);
    const [identificationResponse, setIdentificationResponse] = useState<ITravelIdentificationCodeResponse>(null);
    const [openNoTravelDialog, setOpenNoTravelDialog] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const checkUserPhoneNumber = async ({phone:phoneNumber, birthDate}:{phone:string, birthDate:Date}) => {
        setIdentificationData({phoneNumber, birthDate });
        try{
            const response:ITravelIdentificationCodeResponse = await searchTravelsByPhoneAndBirthdate({phoneNumber, birthDate});
            if( !response?.controlCode ){
                setOpenErrorMessageDialog(true);
            } else {
                setIdentificationResponse(response);
                setIdentificationData( data => ({
                    ...data,
                    identificationCode: response.identificationCodeId
                }));
                setOpenConfirmDialog(true);
            }
        }catch(e){
            setOpenNoTravelDialog(true);
        }
    }

    const retryCodeSend = async () => {
        try{
            const {phoneNumber,birthDate} = identificationData;
            const response:ITravelIdentificationCodeResponse = await searchTravelsByPhoneAndBirthdate({phoneNumber, birthDate});
            if( !response?.controlCode ){
                setOpenErrorMessageDialog(true);
            } else {
                setIdentificationResponse(response);
                setIdentificationData( data => ({
                    ...data,
                    identificationCode: response.identificationCodeId
                }));
                setOpenConfirmDialog(true);
            }
        }catch(e){
            setOpenNoTravelDialog(true);
        }
    }

    const submitCode = async (code:string) => {
        const request = {
            ...identificationData,
            verificationCode: code
        };

        setIdentificationData(request);

        try{
            const response:ITravelVerificationResponse = await verifyTravelsByPhoneAndBirthdate(request);

            if (response?.primaryInsured) {
                onCustomerFound( response.primaryInsured )
            } else {
                throw new Error();
            }
        } catch(e){
            throw new Error("");
        }

    }

    return (
        <div className='find-on-travel'>
            <TravelPhoneNumberDialog 
                isOpen={true} 
                onSubmit={checkUserPhoneNumber}
            />
            <TravelConfirmDialog
                isOpen={openConfirmDialog}
                onSubmit={submitCode}
                onCancel={retryCodeSend}
                phoneNumber={identificationData?.phoneNumber}
                controlCode={identificationResponse?.controlCode}
            />
            <TravelNoDataDialog
                isOpen={ openNoTravelDialog }
                onManual={() => setTab("firstTime")}
                onSearch={() => setOpenNoTravelDialog(false)}
                phoneNumber={identificationData?.phoneNumber}
            />
        </div>
    )
}